import { useFormDataContext } from '../../../lib/contexts';
import { useRef } from 'react';
import { PROPERTY_CONDITION_OPTIONS } from '../../../lib/constants';
import { useFormContext } from 'react-hook-form';
import CustomBackButton from '../../CustomComponents/CustomBackButton';
import { useScrollToTop } from '../../../lib/hooks';

function FormStep1() {
  const { register, setValue, trigger, handleSubmit, formState } =
    useFormContext();
  const { updateFormData, formData } = useFormDataContext();
  const { errors } = formState;
  const property_conditionRef = useRef();

  const handleClickContinue = handleSubmit(async (data) => {
    const isValid = await trigger(['propertycondition']);

    if (!isValid) {
      const [firstErrorKey] = Object.keys(errors);
      const errorRefs = {
        propertycondition: property_conditionRef,
      };

      errorRefs[firstErrorKey]?.current?.focus();
    } else {
      updateFormData({
        propertycondition: data.propertycondition,
        step: formData.step + 1,
      });
    }
  });

  const handleRadioChange = async (e) => {
    await setValue('propertycondition', e.target.value);
    updateFormData({
      propertycondition: e.target.value
    });
    handleClickContinue();
  };

  useScrollToTop();
  
  return (
    <>
      <div id="question1">
        <h3 className="step-title">Tell Us About Your Property!</h3>
        <ul className="radio-list">
          {PROPERTY_CONDITION_OPTIONS.map(
            ({ id, value, textOption, registerLabel }, index) => (
              <li
                key={`${id}-${index}`}
                className={`radio-list-item ${
                  errors[registerLabel] && 'form-step__error'
                }`}
              >
                <input
                  type="radio"
                  value={value}
                  id={id}
                  checked={formData.propertycondition === value}
                  ref={property_conditionRef}
                  {...register(registerLabel, { required: true })}
                  onClick={handleRadioChange} // Call handleRadioChange on change
                />
                <label className="radio-button" htmlFor={id}>
                  <span>{textOption}</span>
                  <div className="radiobutton"></div>
                </label>
              </li>
            )
          )}
        </ul>
        <CustomBackButton/>
      </div>
    </>
  );
}

export default FormStep1;
